// Centralized categories configuration
export const categoriesData = [
  { id: 'all', name: 'allDishes', description: '', count: 0 },
  { id: 'appetizers', name: 'appetizers', description: 'appetizersDesc', count: 0 },
  { id: 'mains', name: 'mainCourse', description: 'mainCourseDesc', count: 0 },
  { id: 'desserts', name: 'desserts', description: 'dessertsDesc', count: 0 },
  { id: 'beverages', name: 'beverages', description: 'beveragesDesc', count: 0 }
];

export const categoriesForEditor = [
  { value: 'all', label: 'Toutes les catégories' },
  { value: 'appetizers', label: 'Entrées' },
  { value: 'mains', label: 'Plats principaux' },
  { value: 'desserts', label: 'Desserts' },
  { value: 'beverages', label: 'Boissons' }
];

export default categoriesData;